<script>
import { Line } from "vue-chartjs";
export default {
  name: "ScaleFeeChart",
  props: {
    value: { type: Object },
    height: { type: Number, default: 200 },
  },
  extends: Line,
  mounted() {
    // console.log(this.value);
    this.renderChart(this.value.dataCollection, this.value.options);
  },
};
</script>